import { Controller } from "@hotwired/stimulus";

// data-controller="faq"
// Handles filtering FAQs by category (all, loans, deposits, general)
export default class extends Controller {
  static targets = ["filterButton", "group"];
  static values = { active: { type: String, default: "all" } };

  connect() {
    this.updateActiveStyles();
    this.filter();
  }

  setFilter(event) {
    const value = event.currentTarget.dataset.filter;
    this.activeValue = value;
    this.updateActiveStyles();
    this.filter();
  }

  filter() {
    const showAll = this.activeValue === "all";
    this.groupTargets.forEach((group) => {
      const cat = group.dataset.category;
      if (showAll || cat === this.activeValue) {
        group.classList.remove("hidden");
      } else {
        group.classList.add("hidden");
      }
    });
  }

  updateActiveStyles() {
    this.filterButtonTargets.forEach((btn) => {
      const isActive = btn.dataset.filter === this.activeValue;
      // Reset to base classes first
      btn.classList.remove(
        "bg-[#FFF3E5]",
        "text-[#E85C0D]",
        "cursor-default",
        "bg-[#F4F4F6]",
        "text-[#5A5B5D]"
      );
      if (isActive) {
        btn.classList.add("bg-[#FFF3E5]", "text-[#E85C0D]", "cursor-default");
      } else {
        btn.classList.add("bg-[#F4F4F6]", "text-[#5A5B5D]");
      }
    });
  }
}
